import React from 'react'
import ManageOrgIntegration from 'src/app/ManageOrgIntegration/ManageOrgIntegration'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { manageOrgIntegrationRouteProps } from 'src/navigation/routeProps'

const ManageOrgIntegrationAppRoute: AppRoute = {
  id: AppLocation.ManageOrgIntegration,
  routeProps: manageOrgIntegrationRouteProps,
  component: <ManageOrgIntegration />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ManageOrgIntegrationAppRoute
